export default __webpack_public_path__ + "static/media/about-9.78a56639.jpg";